import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GlobalFunctions, SnackType, ISQLResult, imagePath, imgTypes } from '@global/GlobalFunctions';
import { AssetsDataService, ILevelAsset, LevelAsset } from '@services/assets-data.service';
import { ILocationGroup, IOrganisationsHierarchy, OrganisationDataService, OrganisationsHierarchy } from '@services/organisation-data.service';
import { Router } from '@angular/router';
import { filter, firstValueFrom, Subject } from 'rxjs';
import { EditHierarchyLocationComponent } from 'src/app/dialogs/edit-hierarchy-location/edit-hierarchy-location.component';
import { MatDialog } from '@angular/material/dialog';
import { EditHierarchyAssetComponent } from 'src/app/dialogs/edit-level-asset/edit-level-asset.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FieldSettingsModel, ListBoxComponent } from '@syncfusion/ej2-angular-dropdowns';
import { EditLevelPermissionComponent } from 'src/app/dialogs/edit-level-permission/edit-level-permission.component';
import { AddLevelPermissionComponent } from 'src/app/dialogs/add-level-permission/add-level-permission.component';
import { response } from 'express';

@Component({
	selector: 'app-hierarchy-manage-location',
	templateUrl: './hierarchy-manage-location.component.html',
	styleUrls: ['./hierarchy-manage-location.component.scss']
})
export class HierarchyManageLocationComponent implements OnInit, OnChanges {

	/** Path to Assets Images */
	public imagePathAssets(): string {
		return imagePath(this.accountID, imgTypes.organisationassets).toLowerCase()
	}

	/** Path to Organisation Images */
	public imagePathOrganisations(): string {
		return imagePath(this.accountID, imgTypes.organisations).toLowerCase()
	}

	/** Path to Sub Location Images */
	public imagePathSubLocations(): string {
		return imagePath(this.accountID, imgTypes.sublocations).toLowerCase()
	}

	/** inputValue */
	@Input() locationUID: string;

	@Input() hierarchyData: IOrganisationsHierarchy[];
	@Input() treeData: IOrganisationsHierarchy[];

	@Input() accountID: string;
	@Input() OrganisationID: string;

	@Output() hierarchyChanged = new EventEmitter<boolean>();

	@ViewChild('locationListbox') locationListbox: ListBoxComponent;
	@ViewChild('assetListbox') assetListbox: ListBoxComponent;

	public selectedLocation: IOrganisationsHierarchy;

	public selectedGroups: ILocationGroup[]
	public selectedGroup: ILocationGroup | undefined
	public inheritedGroups: any
	public selectedinheritedGroup: any

	fields = { text: 'Name', value: 'Uid' };

	public ShowHiddenLocations: number = 1;

	/** Location Form */
	public locationForm: FormGroup;
	/** Form Submitted */
	public submitted: boolean = false;
	/** Form Success */
	public success: any;
	/** Form Error */
	public error: any;

	public locationFields: FieldSettingsModel = { text: 'Name' };
	public assetFields: FieldSettingsModel = { text: 'Name' };

	public permissionsFields: FieldSettingsModel = { text: 'Name' }

	public reOrderLocations: boolean = false;
	private NewLocationOrder?: IOrganisationsHierarchy[] = undefined
	private OldLocationOrder?: IOrganisationsHierarchy[] = undefined

	public reOrderAssets: boolean = false;
	private NewAssetOrder?: LevelAsset[] = undefined
	private OldAssetOrder?: LevelAsset[] = undefined

	/**
	 * Default Constructor
	 * @param globalFunctions 
	 * @param router 
	 * @param assetsDataService 
	 * @param organisationDataService 
	 * @param dialog 
	 * @param formBuilder 
	 */
	constructor(
		private globalFunctions: GlobalFunctions,
		private router: Router,
		private assetsDataService: AssetsDataService,
		private organisationDataService: OrganisationDataService,
		private dialog: MatDialog,
		private formBuilder: FormBuilder) {

		this.locationForm = this.formBuilder.group({
			UID: ['', Validators.required],
			Name: [''],
			Description: [''],
			FunctionLocation: [''],
			ParentFunctionalLocation: ['']
		});
	}

	/**
	 * Hide or unhide a location
	 */
	async toggleHidden() {
		if (this.selectedLocation) {
			this.selectedLocation.Hidden = !this.selectedLocation.Hidden;
		}

		try {
			var response = await firstValueFrom(
				this.organisationDataService.patchOrganisationLocation$(this.accountID, this.OrganisationID, this.selectedLocation)
					.pipe(filter((response) => !!response))
			)

			if (response) {
				this.globalFunctions.DisplaySnackBar({
					message: "Hierarchy Details Updated",
					type: SnackType.Info,
					duration: 1000
				});
			}

			this.hierarchyChanged.emit(true);

		} catch (error: any) {
			if (error.status != 404) {
				this.globalFunctions.HandleError(error, "this.organisationDataService.patchOrganisationLocation$")
			}
		}
		finally { }
	}

	/**
	  * Edit an asset from selectedLocation's listbox
	  * @param editAsset
	  */
	editListAsset(data: any): void {

		let listEditAsset: ILevelAsset = data

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = { ...listEditAsset };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyAssetComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(async result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);

			try {
				var response = await firstValueFrom(
					this.assetsDataService.patchOrganisationAssets$(this.accountID, this.OrganisationID, _edit)
						.pipe(filter((response) => !!response))
				)

				if (response) {
					Object.assign(listEditAsset, result);
					this.updateForm()
					this.globalFunctions.DisplaySnackBar({
						message: "Asset Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				}

				this.hierarchyChanged.emit(true);

			} catch (error: any) {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "this.assetsDataService.patchOrganisationAssets$")
				}
			}
			finally { }

		});
	}

	/**
	 * Delete location from selectedLocation's listbox
	 * @param data
	 */
	deleteListLocation(data: any) {
		let deletedLocation: IOrganisationsHierarchy = data;
		this.globalFunctions.UserConfirm$("Are you sure you want to delete " + deletedLocation.Name + "?").subscribe(async OKResult => {
			if (OKResult) {
				if (deletedLocation.SubChild || deletedLocation.Assets) {
					this.globalFunctions.DisplaySnackBar({
						message: "Cannot Delete, Location is not Empty",
						type: SnackType.Info,
						duration: 5000
					});
				} else {

					try {
						var response = await firstValueFrom(
							this.organisationDataService.deleteOrganisationLocation$(this.accountID, this.OrganisationID, deletedLocation)
								.pipe(filter((response) => !!response))
						)

						if (response) {
							if (this.selectedLocation) { this.updateForm() }
							this.globalFunctions.DisplaySnackBar({
								message: "Location Deleted",
								type: SnackType.Info,
								duration: 1000
							});
						}

						this.hierarchyChanged.emit(true);

					} catch (error: any) {
						if (error.status != 404) {
							this.globalFunctions.HandleError(error, "this.organisationDataService.deleteOrganisationLocation$")
						}
					}
					finally {
						if (this.selectedLocation) { this.updateForm }
						this.hierarchyChanged.emit(true)
					}
				}
			}
		});
	}

	/**
	 * selectGroup
	 * @param grp
	 */
	selectGroup(grp: ILocationGroup) {
		this.selectedGroup = grp
	}


	/**
	 * Delete a location from selectedLocation's listbox (if it is empty)
	 * @param data
	 */
	deleteListAsset(data: any) {

		this.globalFunctions.UserConfirm$("Deleting Assets is not possible yet").subscribe();
		return;

		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		let deletedAsset: ILevelAsset = data;
		this.globalFunctions.UserConfirm$("Are you sure you want to delete " + deletedAsset.Name + "?").subscribe(OKResult => {
			if (OKResult) {
				// this.assetsDataService.deleteAsset$(this.accountID,
				// 	this.OrganisationID, deletedAsset.AssetID).pipe(
				// 		takeUntil(fetchDataSubject), distinctUntilChanged(),
				// 		filter((sqlResult) => !!sqlResult),
				// 		finalize(() => {
				// 			// Ensure the subscription is terminated and the subject is completed
				// 			fetchDataSubject.next();
				// 			fetchDataSubject.complete();
				// 		})
				// 	).subscribe({
				// 		next: (sqlResult: any) => {
				// 			console.log(sqlResult)
				// 			if (this.selectedLocation) { this.updateForm() }
				// 			this.globalFunctions.DisplaySnackBar({
				// 				message: "Asset Deleted",
				// 				type: SnackType.Info,
				// 				duration: 1000
				// 			});
				// 		},
				// 		error: (error) => {
				// 			if (error.status != 404) {
				// 				this.globalFunctions.HandleError(error, "Error: this.AssetsDataService.deleteAsset$", false);
				// 			}
				// 		},
				// 		//complete: () => { console.log("this.AssetsDataService.deleteAsset$.subscribe: Complete"); }
				// 	});
				// if (this.selectedLocation) { this.updateForm }
				// this.hierarchyChanged.emit(true)
			}
		});
	}

	/**
	 * Edit a location from selectedLocation's listbox
	 * @param data
	 */
	editListLocation(data: any): void {

		let listEditLocation: IOrganisationsHierarchy = this.organisationDataService.findObjectByUID(data.Uid, this.hierarchyData)

		// Create a 'Local'/shallow copy of the Location Information
		var _edit = { ...listEditLocation };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyLocationComponent, {
			data: _edit,
		});

		// Update the original Location with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(async result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			try {
				var response = await firstValueFrom(
					this.organisationDataService.patchOrganisationLocation$(this.accountID, this.OrganisationID, _edit)
						.pipe(filter((response) => !!response))
				)

				if (response) {
					Object.assign(listEditLocation, result);
					this.updateForm()
					this.globalFunctions.DisplaySnackBar({
						message: "Location Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				}

				this.hierarchyChanged.emit(true);

			} catch (error: any) {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "this.organisationDataService.patchOrganisationLocation$")
				}
			}
			finally { }

		});
	}

	/**
	 * Edit selectedLocation details
	 * @param editLocation
	 */
	editLocation(): void {

		// Create a 'Local'/shallow copy of the Location Information
		var _edit = { ...this.selectedLocation };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyLocationComponent, {
			data: _edit,
		});

		// Update the original Location with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(async result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			try {
				var response = await firstValueFrom(
					this.organisationDataService.patchOrganisationLocation$(this.accountID, this.OrganisationID, _edit)
						.pipe(filter((response) => !!response))
				)

				if (response) {
					Object.assign(this.selectedLocation, response);
					this.updateForm()
					this.globalFunctions.DisplaySnackBar({
						message: "Location Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				}

				this.hierarchyChanged.emit(true);

			} catch (error: any) {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "this.organisationDataService.patchOrganisationLocation$")
				}
			}
			finally { }

		});
	}

	/**
	 * Add new location
	 * @param subLocation
	 */
	addLocation(subLocation: OrganisationsHierarchy) {

		// Create a 'Local'/shallow copy of the location Information
		var _edit = <IOrganisationsHierarchy>{};

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyLocationComponent, {
			data: _edit,
		});

		// Update the original Location with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(async result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			try {
				var response = await firstValueFrom(
					this.organisationDataService.postOrganisationLocation$(this.accountID, this.OrganisationID, subLocation, _edit)
						.pipe(filter((response) => !!response))
				)

				this.hierarchyChanged.emit(true);

			} catch (error: any) {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "this.organisationDataService.postOrganisationLocation$")
				}
			}
			finally {
				if (this.selectedLocation) { this.updateForm }
				this.hierarchyChanged.emit(true)
			}

		});
	}

	/**
	 * Add new Asset
	 * @param subLocation
	 */
	addAsset(subLocation: OrganisationsHierarchy) {

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = <ILevelAsset>{};

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyAssetComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(async result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			try {
				var response = await firstValueFrom(
					this.assetsDataService.postOrganisationAssets$(this.accountID, this.OrganisationID, subLocation.Uid, _edit)
						.pipe(filter((response) => !!response))
				)
			} catch (error: any) {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "this.organisationDataService.postOrganisationAssets$")
				}
			}
			finally {
				if (this.selectedLocation) { this.updateForm }
				this.hierarchyChanged.emit(true)
			}

		});
	}

	/**
	 * Subscribes to changes in the input values and updates the selected location object
	 * @param changes
	 */
	ngOnChanges(changes: SimpleChanges) {

		this.NewAssetOrder = undefined;
		this.reOrderAssets = false;

		if (this.hierarchyData && this.locationUID != "") {
			this.selectedLocation = this.organisationDataService.findObjectByUID(this.locationUID, this.hierarchyData);
			if (this.selectedLocation) {
				// if (this.selectedLocation) {
				// 	if (this.selectedLocation.Assets) {
				// 		this.selectedLocation.Assets.forEach((Item, index) => {
				// 			Item.ParentOrder = index + 1;
				// 		})
				// 	}
				// }
				this.updateForm()
			}
		}
	}

	/**
	 * Repopulates form and refreshes listboxes
	 */
	updateForm() {
		this.locationForm.get("Name")?.setValue(this.selectedLocation?.Name)
		this.locationForm.get("Description")?.setValue(this.selectedLocation?.Description || "")
		this.locationForm.get("UID")?.setValue(this.selectedLocation?.Uid || "")
		this.locationForm.get("FunctionLocation")?.setValue(this.selectedLocation?.FunctionalLocation || "")
		this.locationForm.get("ParentFunctionalLocation")?.setValue(this.selectedLocation?.ParentFunctionalLocation || "")

		try {

			this.selectedGroups = []
			this.selectedGroup = undefined
			if (this.selectedLocation.Security) {
				this.selectedGroups = JSON.parse(this.selectedLocation.Security)
				this.selectedGroup = this.selectedGroups[0]
			}

		}
		catch (error) {
			console.error(error);
		}
		this.error = null;
		this.success = null;

	}

	/**
	 * View the Image Fullsize
	 * @param imageURL
	 */
	viewImage(imageURL: string) {
		this.globalFunctions.viewImageFullSize(imageURL);

	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {

		if (this.locationUID && this.hierarchyData) {
			this.selectedLocation = this.organisationDataService.findObjectByUID(this.locationUID, this.hierarchyData);
		}

		if (this.selectedLocation) { this.updateForm() }
	}


	addNewGroup(): void {

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = {};

		// Display the dialog box
		const dialogRef = this.dialog.open(AddLevelPermissionComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(async result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			try {
				var SQLResult = await firstValueFrom(
					this.organisationDataService.postOrganisationPermissions$(this.accountID, this.OrganisationID, this.locationUID, result)
						.pipe(filter((response) => !!response))
				)

				if (SQLResult) {
					let response = <ISQLResult>SQLResult
					if (response.Error == "") {
						this.globalFunctions.DisplaySnackBar({
							message: response.Result,
							action: "",
							type: SnackType.Info
						});
						this.hierarchyChanged.emit(true)
						this.updateForm()
					}
					else {
						this.globalFunctions.DisplaySnackBar({
							message: response.Error,
							action: "",
							type: SnackType.Error
						});
					}
				}

			} catch (error: any) {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "this.organisationDataService.postOrganisationPermissions$")
				}
			}
			finally {
				if (this.selectedLocation) { this.updateForm }
				this.hierarchyChanged.emit(true)
			}

		});
	}

	/**
	 * deleteGroup
	 * @param grp
	 */
	deleteGroup(grp: ILocationGroup) {

		this.globalFunctions.UserConfirm$(`Delete the ${grp.Name} Permission?`).subscribe(async OKResult => {
			if (OKResult) {
				try {
					var SQLResult = await firstValueFrom(
						this.organisationDataService.deleteOrganisationPermission$(this.accountID, this.OrganisationID, this.locationUID, grp.AccountGroupID)
							.pipe(filter((response) => !!response))
					)
					if (SQLResult) {
						let response = <ISQLResult>SQLResult
						if (response.Error == "") {
							this.globalFunctions.DisplaySnackBar({
								message: response.Result,
								action: "",
								type: SnackType.Info
							});
							this.hierarchyChanged.emit(true)
							this.updateForm()
						}
						else {
							this.globalFunctions.DisplaySnackBar({
								message: response.Error,
								action: "",
								type: SnackType.Error
							});
						}
					}
				} catch (error: any) {
					if (error.status != 404) {
						this.globalFunctions.HandleError(error, "this.organisationDataService.deleteOrganisationPermission$")
					}
				}
				finally {
					if (this.selectedLocation) { this.updateForm }
					this.hierarchyChanged.emit(true)
				}
			}
		});
	}

	/**
	 * editGroup
	 * @param grp
	 */
	editGroup(grp: ILocationGroup): void {

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = { ...grp };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditLevelPermissionComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(async result => {
			Object.assign(_edit, result);
			try {
				var SQLResult = await firstValueFrom(
					this.organisationDataService.patchOrganisationPermissions$(this.accountID, this.OrganisationID, this.locationUID, result)
						.pipe(filter((response) => !!response))
				)
				if (SQLResult) {
					Object.assign(grp, result);
					let response = <ISQLResult>SQLResult
					if (response.Error == "") {
						this.globalFunctions.DisplaySnackBar({
							message: response.Result,
							action: "",
							type: SnackType.Info
						});
						this.hierarchyChanged.emit(true)
						this.updateForm()
					}
					else {
						this.globalFunctions.DisplaySnackBar({
							message: response.Error,
							action: "",
							type: SnackType.Error
						});
					}
				}
			} catch (error: any) {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "this.organisationDataService.patchOrganisationPermissions$")
				}
			}
			finally {
				if (this.selectedLocation) { this.updateForm }
				this.hierarchyChanged.emit(true)
			}

		});
	}

	/**
	 * goToLocation
	 */
	goToLocation() {
		this.router.navigate([`./${this.accountID}/organisation/${this.OrganisationID}/location/${this.selectedLocation.Uid}`]);
	}

	/**
	 * onAssetListBoxDrop
	 * @param event 
	 */
	onAssetListBoxDrop(event: any): void {
		// console.log('Drop event:', event);
		this.NewAssetOrder = event.source.currentData as LevelAsset[];
		this.NewAssetOrder.forEach((item, index) => {
			item.ParentOrder = index + 1;
		});
	}

	/**
	 * onLocationListBoxDrop
	 * @param event 
	 */
	onLocationListBoxDrop(event: any): void {
		// console.log('Drop event:', event);
		this.NewLocationOrder = event.source.currentData as IOrganisationsHierarchy[];
		this.NewLocationOrder.forEach((item, index) => {
			item.ParentOrder = index + 1;
		});
	}

	/**
	 * toggleReorder
	 */
	toggleReorderAssets() {

		this.reOrderAssets = !this.reOrderAssets;
		this.assetListbox.allowDragAndDrop = this.reOrderAssets;

		if (this.reOrderAssets === false && this.NewAssetOrder) {
			this.globalFunctions.UserConfirm$('Save new Asset Order?').subscribe(async OKResult => {
				if (OKResult) {
					/** Find the selected Location in the tree */
					this.selectedLocation =
						this.organisationDataService.findObjectByUID(
							this.locationUID,
							this.hierarchyData
						);
					try {
						const responses = await Promise.all(
							this.NewAssetOrder!.map(item =>
								firstValueFrom(
									this.assetsDataService.patchOrganisationAssets$(
										this.accountID,
										this.OrganisationID,
										item
									)
								)
							)
						);
						/** Re-assign the hierarchy assets */
						this.selectedLocation.Assets = [...this.NewAssetOrder!];
						this.hierarchyChanged.emit(true);
					} catch (error) {
						// console.error('Failed to update asset order:', error);
						this.globalFunctions.DisplaySnackBar({
							message: 'Failed to update asset order',
							action: "",
							type: SnackType.Error
						});
					}

					this.assetListbox.refresh();
					this.NewAssetOrder = undefined;
					this.OldAssetOrder = undefined;

				} else {
					this.hierarchyChanged.emit(true);
					this.selectedLocation = this.organisationDataService.findObjectByUID(this.locationUID, this.hierarchyData);
					Object.assign(this.selectedLocation.Assets, this.OldAssetOrder!);
					this.assetListbox.refresh();
					this.NewAssetOrder = undefined;
					this.OldAssetOrder = undefined;
				}
			});
		}
		else {
			this.assetListbox.refresh();
			this.NewAssetOrder = undefined;
			this.OldAssetOrder = this.selectedLocation.Assets.map(asset => ({ ...asset }));
		}
	}


	/**
	 * toggleReorderLocations
	 */
	toggleReorderLocations() {

		this.reOrderLocations = !this.reOrderLocations;
		this.locationListbox.allowDragAndDrop = this.reOrderLocations;

		if (this.reOrderLocations === false && this.NewLocationOrder) {
			this.globalFunctions.UserConfirm$('Save new Sub Location Order?').subscribe(async OKResult => {
				if (OKResult) {
					/** Find the selected Location in the tree */
					this.selectedLocation =
						this.organisationDataService.findObjectByUID(
							this.locationUID,
							this.hierarchyData
						);
					try {

						const responses = await Promise.all(
							this.NewLocationOrder!.map(item =>
								firstValueFrom(
									this.organisationDataService.patchOrganisationLocation$(
										this.accountID,
										this.OrganisationID,
										item)
								)
							)
						);
						/** Re-assign the hierarchy assets */
						this.selectedLocation.SubChild = [...this.NewLocationOrder!];
						this.hierarchyChanged.emit(true)
					} catch (error) {
						// console.error('Failed to update Sub Location order:', error);						
						this.globalFunctions.DisplaySnackBar({
							message: 'Failed to update Sub Location order',
							action: "",
							type: SnackType.Error
						});
					}

					this.locationListbox.refresh();
					this.NewLocationOrder = undefined;
					this.OldLocationOrder = undefined;

				} else {
					this.hierarchyChanged.emit(true)
					this.selectedLocation = this.organisationDataService.findObjectByUID(this.locationUID, this.hierarchyData);
					Object.assign(this.selectedLocation.SubChild, this.OldLocationOrder!);

					this.locationListbox.refresh();
					this.NewLocationOrder = undefined;
					this.OldLocationOrder = undefined;
				}
			});
		} else {
			this.locationListbox.refresh();
			this.NewLocationOrder = undefined;
			this.OldLocationOrder = this.selectedLocation.SubChild.map(child => ({ ...child }));
		}
	}

	/**
	 * sortAlphabetical
	 */
	sortAssetsAlphabetical() {
		this.selectedLocation = this.organisationDataService.findObjectByUID(this.locationUID, this.hierarchyData);
		this.NewAssetOrder = this.selectedLocation.Assets.sort((a, b) =>
			a.Name.localeCompare(b.Name)
		);
		this.NewAssetOrder.forEach((Item, index) => {
			Item.ParentOrder = 0; //index + 1;
		})
		this.selectedLocation.Assets = this.NewAssetOrder;
		this.assetListbox.refresh();
	}

	/**
	 * sortAlphabetical
	 */
	sortLocationsAlphabetical() {
		this.selectedLocation = this.organisationDataService.findObjectByUID(this.locationUID, this.hierarchyData);
		this.NewLocationOrder = this.selectedLocation.SubChild.sort((a, b) =>
			a.Name.localeCompare(b.Name)
		);
		this.NewLocationOrder.forEach((Item, index) => {
			Item.ParentOrder = 0; //index + 1;
		})
		this.selectedLocation.SubChild = this.NewLocationOrder;
		this.locationListbox.refresh();
	}
}
